import React from "react";
import Card from "@mui/material/Card";
import { GroupedBarChart } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { formatCash, formatCashFull } from "utils/formatCash";
import useWeeklySpendComparison from "hooks/useWeeklySpendComparison";
import CardHeader from "components/common/CardHeader";
import CustomSkeleton from "components/common/CustomSkeleton";

/** This month against last, week by week. */
const SpendComparisonPanel: React.FC = () => {
  const { t } = useTranslation();
  const { weekCount, thisMonth, lastMonth, currency, loading } =
    useWeeklySpendComparison();

  const weeks = Array.from({ length: weekCount }, (_, index) =>
    t("Wk {{number}}", { number: index + 1 }),
  );

  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        height: "100%",
        padding: "var(--space-6)",
        gap: "var(--space-4)",
      }}
    >
      <CardHeader
        title={t("Spend comparison")}
        subtitle={t("This month vs last, by week")}
      />

      {loading ? (
        <CustomSkeleton variant="graph" />
      ) : (
        <GroupedBarChart
          height={240}
          legend={{ position: "bottom" }}
          xAxis={[{ data: weeks, scaleType: "band" }]}
          yAxis={[
            { valueFormatter: (value) => formatCash(value, currency) ?? "" },
          ]}
          series={[
            {
              id: "lastMonth",
              label: t("Last month"),
              data: lastMonth,
              valueFormatter: (value) => formatCashFull(value, currency),
            },
            {
              id: "thisMonth",
              label: t("This month"),
              data: thisMonth,
              valueFormatter: (value) => formatCashFull(value, currency),
            },
          ]}
        />
      )}
    </Card>
  );
};

export default SpendComparisonPanel;
